function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import { ReactSVG } from 'react-svg';
function parseSvgChildren(children) {
  var level = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  if (children && children.length) {
    [].forEach.call(children, function (item) {
      item.removeAttribute('width');
      item.removeAttribute('height');
      if (item.hasAttribute('fill')) {
        var fill = item.getAttribute('fill');
        if (fill && fill.startsWith('#')) {
          item.setAttribute('fill', 'currentColor');
        }
      }
      if (item.hasAttribute('stroke')) {
        var stroke = item.getAttribute('stroke');
        if (stroke && stroke.startsWith('#')) {
          item.setAttribute('stroke', 'currentColor');
        }
      }
      if (item.hasAttribute('fill-opacity')) {
        item.removeAttribute('fill-opacity');
      }
      if (item.hasAttribute('opacity')) {
        var opacity = item.getAttribute('opacity');
        if (opacity && Number(opacity) >= 0.65) {
          item.removeAttribute('opacity');
        }
      }
      if (item.children && item.children.length) {
        parseSvgChildren(item.children, level + 1);
      }
    });
  }
}
/**
 * svg图片的浏览地址转svg
 * @param props
 * @returns
 */
export function ParseUrl2Svg(props) {
  var _props$src = props.src,
    src = _props$src === void 0 ? '' : _props$src,
    _props$imgHeight = props.imgHeight,
    imgHeight = _props$imgHeight === void 0 ? '24px' : _props$imgHeight,
    _props$wrapper = props.wrapper,
    wrapper = _props$wrapper === void 0 ? 'span' : _props$wrapper,
    _props$imgWidth = props.imgWidth,
    imgWidth = _props$imgWidth === void 0 ? '24px' : _props$imgWidth,
    _props$injection = props.injection,
    injection = _props$injection === void 0 ? true : _props$injection;
  var isSvg = src.indexOf('.svg') > 0;
  var eleProps = {
    src: props.src,
    className: "svg-icon ".concat(props.className || ''),
    onClick: props.onClick,
    color: props.color,
    style: _objectSpread(_objectSpread({}, props.style), {}, {
      width: imgWidth,
      height: imgHeight
    }),
    fontSize: props.fontSize
  };
  if (!src) {
    return null;
  }
  if (isSvg) {
    return /*#__PURE__*/React.createElement(ReactSVG, _objectSpread({
      wrapper: wrapper,
      beforeInjection: function beforeInjection(svg) {
        if (!svg) {
          return;
        }
        if (imgHeight) {
          svg.setAttribute('height', imgHeight);
        }
        if (imgWidth) {
          svg.setAttribute('width', imgWidth);
        }
        svg.classList.add('svg-class-name');
        if (!injection) {
          return;
        }
        svg.setAttribute('fill', 'currentColor');
        var allPath = _toConsumableArray(svg.querySelectorAll('path'));
        if (allPath.length) {
          allPath.forEach(function (g) {
            g.setAttribute('fill', 'currentColor');
          });
        }
        var allG = [].concat(_toConsumableArray(svg.querySelectorAll('g')), _toConsumableArray(svg.querySelectorAll('path')), _toConsumableArray(svg.querySelectorAll('polygon')), _toConsumableArray(svg.querySelectorAll('use')), _toConsumableArray(svg.querySelectorAll('line')));
        if (allG && allG.length) {
          allG.forEach(function (g) {
            if (g.hasAttribute('fill')) {
              var fill = g.getAttribute('fill');
              if (fill && fill.startsWith('#')) {
                g.setAttribute('fill', 'currentColor');
              }
            }
            if (g.hasAttribute('stroke')) {
              var stroke = g.getAttribute('stroke');
              if (stroke && stroke.startsWith('#')) {
                g.setAttribute('stroke', 'currentColor');
              }
            }
          });
        }
      }
    }, eleProps));
  }
  return /*#__PURE__*/React.createElement("img", _objectSpread(_objectSpread({}, eleProps), {}, {
    alt: ""
  }));
}